import { marketplaces } from '@/data/marketplaces';
import { Marketplace } from '@/store/organization/projectSlice';

export const supportedMarketplaces = new Set([
  Marketplace.Ozon,
  Marketplace.Wildberries,
  Marketplace.YandexMarket,
  Marketplace.Vprok,
  Marketplace.Pyaterochka,
  Marketplace.Magnit,
  Marketplace.MagnitCosmetic,
  Marketplace.MVideo,
  Marketplace.DetMir,
  Marketplace.Metro,
  Marketplace.GoldApple,
  Marketplace.KuperAuchan,
  Marketplace.KuperLenta,
  Marketplace.KuperMagnit,
  Marketplace.KuperPerekrestok,
  Marketplace.KuperPyaterochka,
  Marketplace.KuperSuperLenta,
  Marketplace.KuperVprok,
  Marketplace.Aptekaru,
  Marketplace.EApteka,
  Marketplace.Zdravcity,
  Marketplace.Asna,
  Marketplace.Uteka,
]);

const getFilterMarketplaces = () => {
  return Object.entries(marketplaces).filter(([key]) =>
    supportedMarketplaces.has(key as Marketplace)
  );
};

export default getFilterMarketplaces;
